/* Presentation enhancements only; the existing PDP owns variant/cart resolution. */
(() => {
  function init() {
    const page = document.querySelector('.pdp-page');
    if (!page || page.dataset.detailsReady) return;
    page.dataset.detailsReady = 'true';
    const form = page.querySelector('.product-form');
    const colourGroup = [...form.querySelectorAll('[role="radiogroup"]')].find(group => /^(color|colour)$/i.test(group.getAttribute('aria-label')));
    const key = value => String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const matchingGroups = [...page.querySelectorAll('.matching-pieces')];
    const matchingLinks = [...page.querySelectorAll('[data-matching-link]')].map(link => {
      const image = link.querySelector('img');
      const price = link.querySelector('[data-matching-price]');
      const unavailable = link.querySelector('[data-matching-unavailable]');
      return { link, image, price, unavailable, href:link.getAttribute('href'), src:image?.getAttribute('src'), srcset:image?.getAttribute('srcset'), priceText:price?.textContent, unavailableHidden:unavailable?.hidden, colours:[...link.querySelectorAll('[data-matching-option]')] };
    });
    function updateMatchingPieces() {
      const selected = colourGroup?.querySelector('input:checked')?.value;
      matchingLinks.forEach(item => {
        const match = selected && item.colours.find(option => key(option.dataset.colour) === key(selected));
        item.link.hidden = !!selected && !match;
        const url = new URL(item.href, window.location.origin);
        if (match) url.searchParams.set('color', match.dataset.colour);
        item.link.href = url.pathname + url.search;
        if (item.image) {
          item.image.hidden = !!match && !match.dataset.image;
          item.image.setAttribute('src', match?.dataset.image || item.src);
          if (match) item.image.removeAttribute('srcset');
          else if (item.srcset) item.image.setAttribute('srcset', item.srcset);
        }
        if (item.price) item.price.textContent = match ? match.dataset.price : item.priceText;
        if (item.unavailable) item.unavailable.hidden = match ? match.dataset.available === 'true' : item.unavailableHidden;
      });
      matchingGroups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-matching-link]')].some(link => !link.hidden); });
    }
    function updateFacts() {
      const selected = colourGroup?.querySelector('input:checked')?.value;
      page.querySelectorAll('[data-pdp-facts]').forEach(group => {
        const entries = [...group.querySelectorAll('[data-fact-colour]')];
        const match = selected && entries.some(entry => entry.dataset.factColour === key(selected));
        entries.forEach(entry => { entry.hidden = !!match && entry.dataset.factColour !== key(selected); });
      });
    }
    form.addEventListener('change', updateFacts);
    form.addEventListener('pdp:selection', updateMatchingPieces);
    form.addEventListener('change', updateMatchingPieces);
    updateFacts();
    updateMatchingPieces();
    const dialog = document.querySelector('.pdp-enlarged');
    const opener = page.querySelector('[data-pdp-enlarge]');
    if (!dialog || !opener) return;
    const image = dialog.querySelector('[data-pdp-large-image]');
    const zoom = dialog.querySelector('[data-pdp-zoom]');
    function close() {
      dialog.close();
      document.body.classList.remove('pdp-image-open');
      opener.focus({preventScroll:true});
    }
    opener.addEventListener('click', event => {
      const gallery = window.pdpGallery;
      const source = gallery?.slides[gallery.currentIndex]?.querySelector('img');
      if (!source) return;
      event.preventDefault();
      image.src = source.src;
      image.alt = source.alt;
      dialog.classList.remove('is-zoomed');
      zoom.textContent = 'Zoom in +';
      zoom.setAttribute('aria-pressed','false');
      dialog.showModal();
      document.body.classList.add('pdp-image-open');
    });
    zoom.addEventListener('click', () => {
      const enlarged = dialog.classList.toggle('is-zoomed');
      zoom.textContent = enlarged ? 'Zoom out −' : 'Zoom in +';
      zoom.setAttribute('aria-pressed',String(enlarged));
    });
    dialog.querySelector('[data-pdp-close]').addEventListener('click',close);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click',event => { if(event.target===dialog) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
